import { frontendURL } from '../../../../helper/URLHelper';
import { REPORT_ROUTE_PERMISSIONS } from 'dashboard/mostChatwootExtensions/reportAccess';
import SettingsWrapper from '../SettingsWrapper.vue';
import MostInsights from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports/most-insights'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'most_insights',
          component: MostInsights,
          meta: { permissions: [...REPORT_ROUTE_PERMISSIONS, 'agent'] },
        },
      ],
    },
  ],
};
